<template>
    <div class="cardapio-digital-produto">
        <HeaderSimples/>
        <section class="cardapio-digital-produto-section">
            <BuscaProduto
                :layoutGrid="layoutGrid"
                :termoFiltro="termoFiltro"
                @alternarVisualizacao="alternarVisualizacao"
                @aplicarFiltro="aplicarFiltro"
            />
            <!-- <FiltroTipoFamilia v-if="temProdutoPizza"/> -->
            <div class="cardapio-digital-produto-section-lista" :class="tipoVisualizacao">
                <div class="cardapio-digital-produto-section-lista-card" v-for="( produto, index ) in produtosFiltrados" :key="index" @click="redirecionaDetalheProduto(produto)">
                    <img class="cardapio-digital-produto-section-lista-card-img"
                        :src="produto.img" 
                        :alt="produto.descricao" 
                        :title="produto.descricao"
                        onerror="this.onerror=null; this.src='./img/semimagem.png'"
                    >
                    <div class="cardapio-digital-produto-section-lista-card-info">
                        <p class="cardapio-digital-produto-section-lista-card-info-titulo">{{produto.titulo}}</p>
                        <p class="cardapio-digital-produto-section-lista-card-info-detalhe">{{produto.descricao}}</p>
                        <p v-if="!ehProdutoPizza(produto)" class="cardapio-digital-produto-section-lista-card-info-preco">{{produto.preco | currency}}</p>
                        <p v-if="ehProdutoPizza(produto)" class="cardapio-digital-produto-section-lista-card-info-preco preco-pizza">{{valorMinimoPizza(produto) | currency}} - {{valorMaximoPizza(produto) | currency}}</p>
                    </div>
                </div>
            </div> 
            <nenhuma-informacao :visivel="!produtosFiltrados.length"
                    :textoCard="textoCardNenhumaInformacao"
                    :cbEsconde="true">
            </nenhuma-informacao>
        </section>

    </div>
</template>

<script>

import HeaderSimples from './HeaderSimples.vue';
import BuscaProduto from './BuscaProduto.vue';
import NenhumaInformacao from './NenhumaInformacaoEncontrada.vue';
import store from '@/store'
// import FiltroTipoFamilia from './FiltroTipoFamilia.vue';

export default {
    name: 'ListaProduto',
    components: {
        HeaderSimples,
        BuscaProduto,
        NenhumaInformacao
    },
    data() {
        return {
            dados: {},
            produtos: [],
            produtosFiltrados: [],
            termoFiltro: '',
        }
    },
    computed: {
        layoutGrid() {
            return store.state.dadosJson.configuracao ? store.state.dadosJson.configuracao.layoutGrid : true
        },
        tipoVisualizacao() {
            return this.layoutGrid ? 'grid' : 'inline';
        },
        temProdutoPizza() {
            return this.produtosFiltrados.find((produto) => {
                return produto.tpespecialidade === "1"
            })
        },
        textoCardNenhumaInformacao() {
            return this.termoFiltro ? 'Não foi encontrado nenhum resultado de pesquisa para: ' + this.termoFiltro : 'Não encontramos produtos com o filtro selecionado.'
        },
    },
    methods: {
        obterDados() {
            if (store.state.dadosJson.produtos) {
              this.dados = store.state.dadosJson
            } else {
              store.commit('exibirOcultarModalLoading', false)
              this.voltarListaGrupo()
            }
        },
        buscaProdutosJson: function() {
            const idGrupo = this.$route.params.idGrupo;
            this.produtos = idGrupo ? this.dados.produtos.filter((produto) => {
                return produto.grupo === idGrupo
            }) : this.dados.produtos
            this.produtosFiltrados = this.produtos;
        
        },

        alternarVisualizacao() {
            store.commit('alternarVisualizacao', !this.layoutGrid) 
        },

        redirecionaDetalheProduto(produto) {
          this.$router.push({ name: 'DetalheProduto', params: {produto}})
        },

        aplicarFiltro(termoFiltro) {
            this.produtosFiltrados = this.produtos.filter((produto) => {
                return this.substituirCaracteresEspeciais(produto.titulo).toUpperCase().includes(this.substituirCaracteresEspeciais(termoFiltro).toUpperCase()) ||
                       this.substituirCaracteresEspeciais(produto.descricao).toUpperCase().includes(this.substituirCaracteresEspeciais(termoFiltro).toUpperCase()) ||
                       this.consultaPreco(produto, termoFiltro)
            })
        },

        voltarListaGrupo() {
            this.$router.push({ name: 'Grupos'})
        },

        ehProdutoPizza(produto) {
            return produto.tpEspecialidade === "1"
        },

        valorMinimoPizza(produto) {
            var menor = 99999;
            produto.tamanhos.forEach((item) => {
                menor = Number(item.preco) < menor ? item.preco : menor
            })
            return menor
        },
        valorMaximoPizza(produto) {
            var maior = 0;
            produto.tamanhos.forEach((item) => {
                maior = Number(item.preco) > maior ? item.preco : maior
            })
            return maior
        },

        substituirCaracteresEspeciais(texto) {
            const substituicoes = [
                { de: /[áàâãä]/gi, para: 'a' },
                { de: /[éèêë]/gi, para: 'e' },
                { de: /[íìîï]/gi, para: 'i' },
                { de: /[óòôõö]/gi, para: 'o' },
                { de: /[úùûü]/gi, para: 'u' },
                { de: /[ç]/gi, para: 'c' },
            ];

            let resultado = texto;
            for (const s of substituicoes) {
                resultado = resultado.replace(s.de, s.para);
            }
            return resultado;
        },
        substituirCaracteresPreco(texto) {
            const substituicoes = [
                { de: ',', para: '.' },
            ];

            let resultado = texto;
            for (const s of substituicoes) {
                resultado = resultado.replace(s.de, s.para);
            }
            return resultado;
        },

        consultaPreco(produto, termoFiltro) {
            var encontrou = false;
            if (this.ehProdutoPizza(produto)) {
                encontrou = parseFloat(this.valorMinimoPizza(produto)).toFixed(2).toString().replace(',','.').includes(termoFiltro.replace(',','.')) ||
                parseFloat(this.valorMaximoPizza(produto)).toFixed(2).toString().replace(',','.').includes(termoFiltro.replace(',','.'))
            } else {
                encontrou = parseFloat(produto.preco).toFixed(2).toString().replace(',','.').includes(termoFiltro.replace(',','.'))
            }
            return encontrou
        },
    },
    mounted() {
        store.commit('exibirOcultarModalLoading', true)
        this.obterDados();
        this.buscaProdutosJson();
        store.commit('exibirOcultarModalLoading', false)
    }
}
</script>

<style lang="scss" scoped>
    .cardapio-digital-produto{
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 3rem;
    }

    .cardapio-digital-produto-section {
        margin-top: 2vh;
        width: 90vw;
        max-width: 800px;
    }

    .cardapio-digital-produto-section-lista {
        .cardapio-digital-produto-section-lista-card {
            background-color: #EBE8E8;
            padding: 0.7rem;
            border-radius: 1.25rem;
            border: 1px solid rgba(51, 51, 51, 0.2);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            cursor: pointer;

            @media screen and (min-width: 600px) {
              &:hover {
                  transform: scale(1.02);
                  box-shadow: 0px 20px 20px rgba(51, 51, 51, 0.2);
              }
            }

            .cardapio-digital-produto-section-lista-card-img {
                margin: auto;
                width: 97px;
                height: 83px;
                border-radius: 10px;
            }

            .cardapio-digital-produto-section-lista-card-info-titulo{
                font-size: 20px;
                text-align: center;
                font-weight: bold;
                word-break: break-word;
            }

            .cardapio-digital-produto-section-lista-card-info-detalhe{
                font-size: 12px;
                text-align: center;
                max-height: 39px;
            }
            
            .cardapio-digital-produto-section-lista-card-info-preco{
                font-size: 25px;
                font-weight: bold;
                text-align: center;
                
            }
        }

        &.inline {
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: 1rem;

            .cardapio-digital-produto-section-lista-card {
                display: grid;
                grid-template-columns: 1fr 2fr;
            }

            .cardapio-digital-produto-section-lista-card-info {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
            }

            .cardapio-digital-produto-section-lista-card-info-detalhe{
                text-overflow: ellipsis;
                overflow: hidden;
                
            }

            .cardapio-digital-produto-section-lista-card-info-preco{
                margin-top: 0.5rem;
            }
        }

        &.grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax( 9.6rem, 1fr));
            grid-gap: 1rem;
            justify-content: center;

            .cardapio-digital-produto-section-lista-card {
                display: grid;
                grid-template-columns: 1fr;
                grid-template-rows: auto 1fr;
            }

            .cardapio-digital-produto-section-lista-card-img {
                margin: auto;
                width: 127px;
                height: 103px;
                margin-bottom: 5px;
            }

            .cardapio-digital-produto-section-lista-card-info {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }

            .cardapio-digital-produto-section-lista-card-info-detalhe {
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .preco-pizza {
                font-size: 17px;
            }
        }
    }

</style>